import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@fontsource/titan-one/index.css";
import "@fontsource/montserrat/600.css";
import { captureAttribution } from "./lib/analytics/dataLayer";

// Enforce canonical https://sonsisland.com (no www, no http) before render.
// Consolidates indexing signals — Google currently has http:// and www. indexed separately.
if (typeof window !== "undefined") {
  const host = window.location.hostname;
  const isProd = host === "sonsisland.com" || host === "www.sonsisland.com";
  const needsHttps = window.location.protocol === "http:" && isProd;
  const needsApex = host === "www.sonsisland.com";
  if (needsHttps || needsApex) {
    window.location.replace(
      "https://sonsisland.com" + window.location.pathname + window.location.search + window.location.hash
    );
  }
}

// Capture ad click IDs once per session for downstream GTM tags.
captureAttribution();

createRoot(document.getElementById("root")!).render(<App />);
